import * as ActionTypes from '../ActionTypes';

const InitialState = {
    isLoading: false,
    my_attendance_permission: [],
    approver_emp_permission_mapping: []
}

export const MyAttendancePermissionReducer = function (state = InitialState, action) {
    switch (action.type) {
        case ActionTypes.GET_MY_ATTENDANCE_PERMISSION_REQUEST:
            return {
                ...state,
                isLoading: true,
                my_attendance_permission: []
            };
        case ActionTypes.GET_APPROVER_EMP_PERMISSION_MAPPING_REQUEST:
            return {
                ...state,
                isLoading: true,
                approver_emp_permission_mapping: []
            };
        case ActionTypes.UPSERT_MY_ATTENDANCE_PERMISSION_REQUEST:
        case ActionTypes.DELETE_MY_ATTENDANCE_PERMISSION_REQUEST:
        case ActionTypes.UPDATE_APPROVER_EMP_PERMISSION_MAPPING_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.GET_MY_ATTENDANCE_PERMISSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                my_attendance_permission: action.payload?.data?.data
            };
        case ActionTypes.GET_APPROVER_EMP_PERMISSION_MAPPING_SUCCESS:
        case ActionTypes.UPDATE_APPROVER_EMP_PERMISSION_MAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                approver_emp_permission_mapping: action.payload?.data?.data
            };
        case ActionTypes.UPSERT_MY_ATTENDANCE_PERMISSION_SUCCESS:
        case ActionTypes.DELETE_MY_ATTENDANCE_PERMISSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case ActionTypes.GET_MY_ATTENDANCE_PERMISSION_ERROR:
        case ActionTypes.UPSERT_MY_ATTENDANCE_PERMISSION_ERROR:
        case ActionTypes.DELETE_MY_ATTENDANCE_PERMISSION_ERROR:
        case ActionTypes.GET_APPROVER_EMP_PERMISSION_MAPPING_ERROR:
        case ActionTypes.UPDATE_APPROVER_EMP_PERMISSION_MAPPING_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}